import type { ReactNode } from 'react';
import { StaffHeader } from '@/components/elements/StaffHeader';

interface StaffLayoutProps {
  children: ReactNode;
  showLogout?: boolean;
  sidebar?: ReactNode;
}

export const StaffLayout = ({
  children,
  showLogout = true,
  sidebar,
}: StaffLayoutProps) => {
  return (
    <div className="wrap">
      <StaffHeader showLogout={showLogout} />
      <div className="page page_e page_e1">
        <main className="page__main">
          <div className="page__content">
            <section className="e__section">{children}</section>
          </div>
        </main>
        {sidebar}
      </div>
      <footer>
        <div className="footer">
          <div className="footer__line">
            <div className="footer__inner" />
          </div>
        </div>
      </footer>
    </div>
  );
};
